import { render, staticRenderFns } from "./dmp.vue?vue&type=template&id=9dc4319c&scoped=true&"
import script from "./dmp.vue?vue&type=script&lang=js&"
export * from "./dmp.vue?vue&type=script&lang=js&"
import style0 from "./dmp.vue?vue&type=style&index=0&id=9dc4319c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc4319c",
  null
  
)

export default component.exports